import axios from 'axios';
import { maintenanceStore } from '@/utils/maintenanceStore';
import { getToken, clearSessionAuth } from '@/utils/sessionAuth';

const instance = axios.create({
  baseURL: '/api',
  timeout: 30000
});

/** 判定为「服务不可用 / 维护」：网络断开、超时、后端未启动、网关层 502/503/504 */
function shouldEnterMaintenance(error) {
  if (axios.isCancel(error)) return false;
  if (error.response) {
    const s = error.response.status;
    if (s === 401) return false;
    return s === 502 || s === 503 || s === 504;
  }
  // 无 response：连接拒绝、DNS、CORS 网络层、超时等
  if (error.code === 'ECONNABORTED') return true;
  if (error.message === 'Network Error') return true;
  return true;
}

instance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const data = error.response.data;
      if (data && data.code === 'ACCOUNT_DISABLED' && data.message) {
        sessionStorage.setItem('loginFlashMessage', data.message);
      }
      clearSessionAuth();
      // 兼容旧版缓存：同时清理 localStorage，避免跨 Tab 干扰
      localStorage.removeItem('token');
      localStorage.removeItem('account');
      localStorage.removeItem('userRole');
      localStorage.removeItem('roleCode');
      window.location.href = '/login';
      return Promise.reject(error);
    }
    // 天地图驾车路径等接口上游失败常返回 502，不应触发全站「维护中」遮罩
    const reqUrl = (error.config && error.config.url) || '';
    const isMapDriveRoute = typeof reqUrl === 'string' && reqUrl.includes('/map/drive-route');
    if (shouldEnterMaintenance(error) && !isMapDriveRoute) {
      maintenanceStore.active = true;
    }
    return Promise.reject(error);
  }
);

/** 管理后台登录：获取一次性 RSA 公钥（密码用公钥加密后再 POST /auth/login） */
export function fetchLoginRsaKey() {
  return instance.post('/auth/login-rsa-key', {}).then((res) => res.data);
}

export function login(data) {
  return instance.post('/auth/login', data).then((res) => res.data);
}

export function logout() {
  return instance.post('/auth/logout', {}).then((res) => res.data);
}

export default instance;

